import React from 'react';
import { bool, string } from 'prop-types';

const IconEye = props => {
  const { className, visible } = props;

  if (visible) {
    return (
      <svg
        className={className}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.3037 7.22144C17.9443 15.6199 6.05577 15.6199 2.69637 7.22144L1.30366 7.77852C1.81159 9.04836 2.48912 10.1512 3.29163 11.087L0.939346 13.4393L2.00001 14.5L4.3426 12.1574C5.37607 13.0764 6.55083 13.7742 7.79885 14.2507L6.96473 17.3637L8.41362 17.7519L9.23296 14.6941C11.0464 15.129 12.9536 15.129 14.7671 14.6941L15.5864 17.7519L17.0353 17.3637L16.2012 14.2507C17.4492 13.7742 18.6239 13.0764 19.6574 12.1574L22 14.5L23.0607 13.4393L20.7084 11.087C21.5109 10.1512 22.1884 9.04836 22.6964 7.77852L21.3037 7.22144Z"
          fill="black"
        />
      </svg>
    );
  }

  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.69636 12.7786C6.05576 4.38011 17.9443 4.38011 21.3036 12.7786L22.6964 12.2215C18.8341 2.56581 5.16594 2.56581 1.30365 12.2215L2.69636 12.7786Z"
        fill="black"
      />
      <path
        d="M12 15.0001C13.6569 15.0001 15 13.6569 15 12.0001C15 10.3432 13.6569 9.00006 12 9.00006C10.3431 9.00006 9 10.3432 9 12.0001C9 13.6569 10.3431 15.0001 12 15.0001Z"
        fill="black"
      />
    </svg>
  );
};

IconEye.defaultProps = { className: null };

IconEye.propTypes = {
  className: string,
  visible: bool,
};

export default IconEye;
